module.exports = __webpack_public_path__ + "static/regOffice-f0c08903bbc5f0c7e5d5da5cde53b4f7.jpg";